import { ANALYTICS_CONSTANTS, trackEDDL } from '../../../../utilities/analytics';
import Button from '@mui/material/Button';
import { useMuiMediaQuery } from '../../../../utilities/hooks';
import FaqIcon from './FaqIcon';
import { MouseEvent } from 'react';

interface FaqSectionLinkProps {
    title: string;
    url: string;
}

const handleOnClick = (e: MouseEvent, name: string, url: string) => {
    e.preventDefault();
    // Analytics
    trackEDDL({
        event: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
        linkDetails: {
            name,
            position: 'faq',
        },
    });

    window.location.href = url;
};

const FaqSectionLink = ({ title, url }: FaqSectionLinkProps) => {
    const { isMobile } = useMuiMediaQuery();
    return (
        <Button
            variant="outlined"
            color="secondary"
            size={isMobile ? 'medium' : 'large'}
            // Use Href so it shows up as a link for SEO
            href={url}
            // Use JS for EDDL + nav
            onClick={(e) => handleOnClick(e, title, url)}
            startIcon={<FaqIcon title={title} />}
        >
            {title}
        </Button>
    );
};

export default FaqSectionLink;
